import React from "react";

interface IProps {
  value: string;
  placeholder: string;
  onChange: (e: any) => void;
}

export const YearInput: React.FC<IProps> = ({ value, placeholder, onChange }) => {

  return (
    <input
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className='resizeable-accessibility'
    />
  );
};
